import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ImagemBemVindo from 'assets/img/HomeFas.svg';
import { privateRoot, pesquisarProtocolo } from 'routes/paths';
import Button from 'components/Button/index';
import { fetchSalvarInputsFormularios } from 'store/fetchActions/fetchInputForm';
import { IS_TROCA_PERFIL, IS_NEW_LOGIN, USUARIO_LOGADO_FAS, FORMULARIOS } from 'utils/consts';
import { altImagemBemVindo } from 'utils/acessibilidade';
import { FileProtectOutlined, QuestionCircleOutlined, UserOutlined, SearchOutlined } from '@ant-design/icons';
import * as S from './styles';

export default function HomePublic() {
  const history = useHistory();
  const dispatch = useDispatch();

  const unitaryTests = useSelector(state => state.app.unitaryTests);

  React.useEffect(() => {
    if (unitaryTests) return;
    sessionStorage.removeItem(USUARIO_LOGADO_FAS);
    dispatch(fetchSalvarInputsFormularios({}));
    if (localStorage.getItem(IS_TROCA_PERFIL) || localStorage.getItem(IS_NEW_LOGIN)) {
      localStorage.removeItem(IS_TROCA_PERFIL);
      localStorage.removeItem(IS_NEW_LOGIN);
      history.push(privateRoot);
    }
    // eslint-disable-next-line
  }, [dispatch, history]);

  return (
    <S.Page>
      <S.DivText>
        <h1>FAS</h1>
        <h2>FORMULÁRIO DE ATENDIMENTO SEFAZ</h2>
        <p>
          O FAS (Formulário de Atendimento SEFAZ) é uma plataforma que oferece conforto e agilidade aos contribuintes
          quando desejam realizar solicitações junto à SEFAZ ou esclarecer dúvidas. Com apenas alguns cliques, o FAS
          disponibiliza uma ampla gama de serviços. Além disso, a interface intuitiva do FAS facilita a navegação e
          proporciona uma experiência agradável ao usuário, tornando todo o processo simples e rápido. Portanto, contar
          com o FAS é garantir comodidade e eficiência no relacionamento com a SEFAZ, permitindo que os contribuintes
          realizem suas atividades burocráticas de forma mais ágil e descomplicada.
        </p>
        <S.ButtonContainer>
          <Button
            icon={<FileProtectOutlined />}
            text="Solicitar Serviço "
            route={FORMULARIOS.SERVICOS.rota}
            clickAction={() => history.push(FORMULARIOS.SERVICOS.rota)}
          />
          <Button
            icon={<QuestionCircleOutlined />}
            text="Dúvida e Informações "
            route={FORMULARIOS.DUVIDAS.rota}
            clickAction={() => history.push(FORMULARIOS.DUVIDAS.rota)}
          />
          <Button
            icon={<SearchOutlined />}
            text="Consultar Requerimento "
            route={pesquisarProtocolo}
            clickAction={() => history.push(pesquisarProtocolo)}
          />
          <Button
            icon={<UserOutlined />}
            text="Fazer Login "
            route={privateRoot}
            clickAction={() => history.push(privateRoot)}
          />
        </S.ButtonContainer>
      </S.DivText>
      <S.DivImage>
        <S.Imagem src={ImagemBemVindo} title="Bem-vindo(a)" alt={altImagemBemVindo} data-testid="imagemBemVindoFas" />
      </S.DivImage>
    </S.Page>
  );
}
